// WhatsApp message templates used to render the human-readable message shown in
// the logs "View" modal. The placeholders {{1}}, {{2}}, ... are filled in order
// from the `parameters` array stored in each log's `message` payload.
//
// Parameter order MUST match the backend WhatsappService::getTemplateConfig()
// definitions so {{n}} maps to the correct value.

export const WHATSAPP_TEMPLATES = {
  check_in_reminder: `Dear {{1}},

This is a friendly reminder that your check-in at {{2}} is scheduled for {{3}}.

We look forward to welcoming you and wish you a pleasant stay. Safe travels!`,

  payment_reminder: `Dear {{1}},

This is a friendly reminder regarding your booking at {{2}} scheduled for {{3}}.

Please complete your pending payment to confirm your stay.`,

  check_out_reminder: `Dear {{1}},

This is a reminder that your check-out from {{2}} is scheduled for {{3}}.

We hope you enjoyed your stay. Have a safe journey, and we look forward to welcoming you again.`,

  booking_confirmation: `Dear {{1}},

Your booking at {{2}} has been confirmed successfully.

Booking ID: {{3}}
Check-in: {{4}}
Check-out: {{5}}

We look forward to hosting you and hope you have a pleasant stay.

For more information or assistance, please contact us:
Call: {{6}}
Email: {{7}}

Thank you for choosing us. We look forward to welcoming you!`,

  cancellation_confirmation: `Dear {{1}},

Your booking at {{2}} has been cancelled successfully.

Booking ID: {{3}}
Check-in: {{4}}
Check-out: {{5}}

If this cancellation was unexpected or you need any assistance, please feel free to contact our support team.

For more information or assistance, please contact us:
Call: {{6}}
Email: {{7}}

We hope to serve you again in the future.

Thank you for choosing us.`,

  thank_you: `Dear {{1}},

Thank you for choosing {{2}}.

It was our pleasure to host you.

We truly appreciate your visit and look forward to welcoming you again in the future.`,
};

// Human-friendly labels for template names shown in the modal header.
export const WHATSAPP_TEMPLATE_LABELS = {
  check_in_reminder: "Check-in Reminder",
  // payment_reminder: "Payment Reminder",
  check_out_reminder: "Check-out Reminder",
  booking_confirmation: "Booking Confirmed",
  cancellation_confirmation: "Booking Cancelled",
  thank_you: "Thank You",
};

// Safely parse a JSON string; returns null on failure.
export const safeParseJson = (value) => {
  if (value == null) return null;
  if (typeof value === "object") return value;
  try {
    return JSON.parse(value);
  } catch (e) {
    return null;
  }
};

// Render the template text for a parsed message payload by substituting the
// ordered `parameters` values into the {{1}}, {{2}}, ... placeholders.
// Falls back gracefully when the template is unknown or the payload is malformed.
export const renderWhatsappMessage = (messagePayload) => {
  const payload =
    typeof messagePayload === "string"
      ? safeParseJson(messagePayload)
      : messagePayload;

  if (!payload || typeof payload !== "object") {
    return { text: null, templateName: null, parameters: [] };
  }

  const templateName = payload.template_name || null;
  const parameters = Array.isArray(payload.parameters)
    ? payload.parameters
    : [];

  const template = templateName ? WHATSAPP_TEMPLATES[templateName] : null;

  if (!template) {
    // Unknown template: present the parameter values as a readable list.
    const text = parameters
      .map((p) => `${p.name}: ${p.value}`)
      .join("\n");
    return { text: text || null, templateName, parameters };
  }

  // Replace {{1}}, {{2}}, ... with parameter values by position (1-indexed).
  const text = template.replace(/\{\{(\d+)\}\}/g, (match, index) => {
    const param = parameters[Number(index) - 1];
    return param != null && param.value != null ? String(param.value) : match;
  });

  return { text, templateName, parameters };
};
